import $ from "jquery";
import apiFetch from "@wordpress/api-fetch";
import { smoothscroll } from "../utils/smoothscroll";
import { flipSign } from "../utils/functions";
import {
  reloadScriptActions,
  reloadScriptCommentEdit,
} from "./comment-actions";

const $window = $(window);

const commentInit = (el) => {
  const data = {
    postId: el.data("post"),
    content: "",
    parentId: "",
  };

  bindCommentInput(el, data);
  bindTextAreas(el);

  // loadComments(el, data);
};

const bindCommentInput = (element, data) => {
  element.off("submit");
  element.on("submit", ".post-card__form", (e) => e.preventDefault());

  element.off("click");
  element.on("click", ".post-card__send", async function () {
    const $thisEl = $(this);
    const isChild = $thisEl.closest(".post-card__reply-thread").length;
    const commentId = $thisEl.closest(".post-card__comment").data("comment");

    data.content = $thisEl.parent().find(".post-card__input").val();

    if (isChild) {
      data.parentId = $thisEl.closest(".post-card__comment").data("comment");
      await reRenderComments(element, data);

      data.parentId = "";

      const $comments = element
        .find(`.post-card__comment[data-comment="${commentId}"]`)
        .find(".post-card__comments");

      smoothscroll(
        $comments,
        flipSign($comments.outerHeight()) + $window.height()
      );
    } else {
      await reRenderComments(element, data, true);
      smoothscroll(element, flipSign(element.height()) + $window.height());
    }
  });
};

const reRenderComments = (element, data) =>
  new Promise(async (resolve) => {
    const result = await createComment(data);
    element.html(result.html);

    reloadScriptActions();
    reloadScriptCommentEdit();
    resolve();
  });

const bindTextAreas = (element) => {
  element.off("input", ".post-card__input, .post-card__textarea");
  element.on(
    "input",
    ".post-card__input, .post-card__textarea",
    resizeTextAreas
  );
};

export function resizeTextAreas(element = false) {
  element && element instanceof $
    ? element.each(function () {
        resizeSingleTextArea($(this));
      })
    : resizeSingleTextArea($(this));
}

const resizeSingleTextArea = (area) => {
  if (area && area instanceof $) {
    area.css("height", "");
    area.css("height", area.get(0).scrollHeight + "px");

    area.get(0).scrollHeight > 62
      ? area.css("border-radius", "20px")
      : area.css("border-radius", "200px");
  }
};

const createComment = async (data) => {
  try {
    const response = await apiFetch({
      path: "/xixoio/v1/comment/create/" + data.postId,
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      data: data,
    });

    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
};

// const loadComments = async (el, data) => {
//   try {
//     const response = await apiFetch({
//       path: "/xixoio/v1/comment/list/" + data.postId,
//       method: "POST",
//       headers: new Headers({
//         "Content-Type": "application/json",
//       })
//     });

//     return response;
//   } catch (e) {
//     console.log(e);
//     return null;
//   }
// }

export const reloadScriptComment = () => {
  const $commentsEl = $(".post-card__comments-wrapper");

  $commentsEl.each(function () {
    commentInit($(this));
  });
};
reloadScriptComment();
